/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IRadiationType } from 'app/shared/model/radiation-type.model';
import { IFrequency } from 'app/shared/model/frequency.model';
import { ISequence } from 'app/shared/model/sequence.model';
import { IDosageGuideline } from 'app/shared/model/dosage-guideline.model';
import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';
import { IOrganAtRisk } from 'app/shared/model/organ-at-risk.model';
import { IRadiationConstraint } from 'app/shared/model/radiation-constraint.model';
import { IRegimenCycle } from 'app/shared/model/regimen-cycle.model';

export interface IRadiationSession {
  id?: string;
  name?: string | null;
  description?: string | null;
  totalDose?: string | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  radiation?: IRadiationType | null;
  frequency?: IFrequency | null;
  sequence?: ISequence | null;
  dose?: IDosageGuideline | null;
  fractionationScheme?: IClinicalDictionary | null;
  targetVolume?: IClinicalDictionary | null;
  organs?: IOrganAtRisk[] | null;
  constraints?: IRadiationConstraint[] | null;
  cycle?: IRegimenCycle | null;
}

export const defaultValue: Readonly<IRadiationSession> = {
  active: false,
};
